module.exports = __webpack_public_path__ + "static/media/bg-g@3x.15f9d94a.png";